class NSS5050Carousel extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.swiper;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][50/50 Carousel] Connected.");

    const carouselEl = this.querySelector(`.swiper`);

    this.swiper = new Swiper(carouselEl, {
      autoHeight: true,
      grabCursor: true,
      slidesPerView: 1,
      direction: "horizontal",

      breakpoints: {
        990: {
          direction: "vertical",
        },
      },

      a11y: {
        enabled: true,
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
  
    });

  }
}

let elementName = `nss-5050-carousel`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSS5050Carousel);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}